import React from 'react';

const TipContext = React.createContext({});

export const TipContextProvider = TipContext.Provider;
export const TipContextConsumer = TipContext.Consumer;

export default TipContext;
